import { StatCard } from "@design-system/StatCard/StatCard";

import { useTotalTenantsStatQuery } from "./TotalTenantsStat.g";

export const TotalTenantsStat = () => {
  const { data, isLoading } = useTotalTenantsStatQuery();

  const tenantCount = data?.clients?.totalCount ?? 0;

  return (
    <StatCard
      icon="faBuilding"
      title="Total tenants"
      value={tenantCount.toString()}
      isLoading={isLoading}
    />
  );
};